import { Card, CardBody, Col, Row } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { NESTING_DATA } from "../../../../Data/UiKit/Grid";
import { Nesting } from "../../../../Constant";
import { NestingCardBody } from "./NestingCardBody";

const NestingCart = () => {
  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={Nesting} span={NESTING_DATA} />
        <CardBody className="grid-showcase">
          <Row className="g-3">
            <NestingCardBody />
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};

export default NestingCart;
